import React from 'react'
import PropTypes from 'prop-types'
import './TrashCell.css'
import {Trash2, Loader2} from 'lucide-react'

export const TrashCell = ({ onClick, style = {}, size = 16, loading = false }) => (
    loading ? (
        <Loader2 size={size} style={style} className="DataTable-TrashCell DataTable-TrashCell-loading" />
    ) : (
        <Trash2 size={size} style={style} className="DataTable-TrashCell" onClick={event => {
            event.stopPropagation()
            event.nativeEvent.stopImmediatePropagation(); // 🔥 AG Grid native listener
            event.nativeEvent.stopPropagation();          // extra safety
            onClick()
            console.log('trash column clicked')
        }} />
    )
)

TrashCell.propTypes = {
    onClick: PropTypes.func,
    loading: PropTypes.bool,
    style: PropTypes.object,
    size: PropTypes.number
}

export default TrashCell
